import { createPinia } from 'pinia'
import piniaPersist from './persisted-state'

export const pinia = createPinia();
pinia.use(piniaPersist);